import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-miscellaneous',
  template: `
     <nb-card>
      <nb-card-header>
      <div class="row">
      <div class="col-sm-6">
      {{ title }}
      </div>
      <div class="col-sm-6">
      <button nbButton (click)="close()" size="tiny" status="primary" style="float:right">Close</button>
      </div>
      </div>
      </nb-card-header>
      <nb-card-body>
        <p>{{ message }}</p>
        <br>
        <h6 class="text-danger">{{ errorMessage }}</h6>
      </nb-card-body>
    </nb-card>
  `,
})
export class MiscellaneousComponent {
  title: string;
  message: string;
  errorMessage: string;

  constructor(protected ref: NbDialogRef<MiscellaneousComponent>) { }

  close() {
    this.ref.close();
  }
}
